import * as React from 'react';
import { compose, defaultProps } from 'recompose';
import { userAgentParser } from '@soluto-home-web/platform-utils';
import IENotSupportedMessage from '../components/IENotSupportedMessage';
import { withTweekKeys } from 'react-tweek';

const withIENotSupportedMessage = (WrappedComponent) => ({ isIEBrowser, isIEBrowserSupported, ...other }) =>
  isIEBrowser && !isIEBrowserSupported ? <IENotSupportedMessage /> : <WrappedComponent {...other} />;

type OuterProps = {
  WrappedComponent: React.SFC<InnerProps>;
};

type InnerProps = {
  isIEBrowserSupported: boolean;
  isIEBrowser: boolean;
};

export default compose<InnerProps, OuterProps>(
  defaultProps({
    isIEBrowser: userAgentParser.isIEBrowser(),
  }),
  withTweekKeys({ isIEBrowserSupported: 'soluto_home_web/browsers/is_ie_supported' }),
  withIENotSupportedMessage
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/hoc/withIENotSupportedMessage.tsx